module.exports = __webpack_public_path__ + "img/AdobeStock_324185211.3d2503c2.jpeg";